import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Phone, Star } from 'lucide-react';
import { BUSINESS, IMAGES } from './data';
export function Hero() {
  return <section id="top" className="relative isolate flex min-h-[92vh] w-full items-center overflow-hidden" data-id="element-113" data-mp="elkwck89jonr">
      <img src={IMAGES.frontyard} alt="Landscaped desert front yard at dusk with lit paver walkway" className="absolute inset-0 -z-20 h-full w-full object-cover" data-id="element-114" data-mp="9mreygpuvdib" />
      <div className="absolute inset-0 -z-10 bg-brand-ink/25" data-id="element-115" data-mp="12b6quudoxfpf" />
      <div className="absolute inset-0 -z-10 bg-gradient-to-r from-brand-ink via-brand-ink/85 to-brand-ink/40" data-id="element-116" data-mp="12byosburfpiv" />
      <div className="absolute inset-0 -z-10 bg-gradient-to-t from-brand-ink/80 via-transparent to-brand-ink/35" data-id="element-117" data-mp="xidna9tykdex" />

      <div className="mx-auto w-full max-w-7xl px-4 pt-28 pb-16 sm:px-6 lg:px-8" data-id="element-118" data-mp="1q0rbritemn1c">
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        ease: 'easeOut'
      }} className="max-w-2xl [text-shadow:0_2px_16px_rgba(0,0,0,0.8)]" data-id="element-119" data-mp="1q2udh03x64lw">
          <span className="inline-flex items-center gap-2 rounded-full border border-white/20 bg-brand-ink/45 px-4 py-1.5 text-xs font-semibold uppercase tracking-wider text-white shadow-lg backdrop-blur-sm" data-id="element-120" data-mp="3nj3pp4uqnqlv">
            <span className="h-2 w-2 rounded-full bg-brand-red" data-id="element-121" data-mp="3epicvr24wjf3" />
            {BUSINESS.region}
          </span>

          <h1 className="mt-6 font-heading text-4xl font-bold leading-tight tracking-tight text-white sm:text-5xl lg:text-6xl" data-id="element-122" data-mp="2zshr046mjioj">
            Transform your outdoor space with pro turf, pavers & landscaping
          </h1>

          <p className="mt-5 max-w-xl text-lg leading-relaxed text-white/80" data-id="element-123" data-mp="2qunzr7npvf88">
            Plote Professional Services designs and builds standout residential and
            commercial landscapes across Arizona — from artificial turf and paver
            patios to full desert transformations.
          </p>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center" data-id="element-124" data-mp="txyo0urp6px3">
            <a href="#contact" className="inline-flex items-center justify-center gap-2 rounded-full bg-brand-red px-7 py-3.5 text-base font-semibold text-white transition-colors hover:bg-brand-red-dark" data-id="element-125" data-mp="rmz8eaadtdsq">
              Get a free quote
              <ArrowRight className="h-4 w-4" data-id="element-126" data-mp="dn6iuiald3mc" />
            </a>
            <a href={BUSINESS.phoneHref} className="inline-flex items-center justify-center gap-2 rounded-full border border-white/25 bg-white/5 px-7 py-3.5 text-base font-semibold text-white backdrop-blur transition-colors hover:bg-white/10" data-id="element-127" data-mp="1b9dnfs6wavyp">
              <Phone className="h-4 w-4" data-id="element-128" data-mp="wkqw0s3zudr4" />
              {BUSINESS.phoneDisplay}
            </a>
          </div>

          <div className="mt-9 flex items-center gap-3 text-sm text-white/75" data-id="element-129" data-mp="1tzv42yege13p">
            <div className="flex" aria-hidden="true" data-id="element-130" data-mp="1u1xydumn2ge8">
              {Array.from({
              length: 5
            }).map((_, i) => <Star key={i} className="h-4 w-4 fill-brand-red text-brand-red" data-id="element-131" data-mp="1wkt046xgh75s" data-mpi={i} />)}
            </div>
            <span data-id="element-132" data-mp="21j4dusqvg1ta">Trusted by Arizona homeowners & businesses</span>
          </div>
        </motion.div>
      </div>
    </section>;
}